module.exports = __webpack_public_path__ + "static/media/Icon_View.9324c169.svg";